import React from "react";
import PropTypes from "prop-types";
import capitalize from "lodash/capitalize";
import { ScreenReaderOnly } from "@xo-union/ui-accessibility";

const ScreenReaderPrefix = _ref => {
  let {
    type,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(ScreenReaderOnly, props, `${capitalize(type)}: `);
};

process.env.NODE_ENV !== "production" ? ScreenReaderPrefix.propTypes = {
  type: PropTypes.string
} : void 0;
export default ScreenReaderPrefix;